import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ExpandableSection } from '../ExpandableSection';
import { FuncionarioDetails } from './FuncionarioDetails';
export var ExpandableSectionFuncionarios = function (_a) {
    var funcionarios = _a.funcionarios;
    return (_jsx(ExpandableSection, { title: "Dados dos Funcion\u00E1rios", children: funcionarios === null || funcionarios === void 0 ? void 0 : funcionarios.map(function (funcionario, index) { return (_jsx(FuncionarioDetails, { funcionario: funcionario, index: index + 1 }, funcionario.id)); }) }));
};
